import { IconProps } from "./";
import Icon from "./assets/edit_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Edit(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
